import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { showError } from '../../../../core/alert/sweetAlertConfig';

interface DoorDTO {
  id: number;
  name: string;
  roomId: number;
  floorId: number;
  buildingId: number;
  description?: string;
  createdBy: string;
  createdAt: string;
  updatedBy?: string;
  updatedAt?: string;
  // doorType?: string | null; // uncomment if you have this field
}

interface ViewDoorModuleProps {
  show: boolean;
  onHide: () => void;
  door: DoorDTO | null;
}

const ViewDoorModule: React.FC<ViewDoorModuleProps> = ({ show, onHide, door }) => {
  if (!door) {
    showError('No door data available. Please try again.');
    return null;
  }

  const fmtDate = (d?: string) => (d ? new Date(d).toLocaleString() : '-');

  const DisplayField: React.FC<{ label: string; value?: React.ReactNode }> = ({ label, value }) => (
    <div className="mb-3">
      <div className="text-muted small mb-1">{label}</div>
      <div className="fw-semibold border rounded px-2 py-2 bg-light-subtle">{value ?? '-'}</div>
    </div>
  );

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Door Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="g-3">
          <Col xs={12} md={4}>
            <DisplayField label="ID" value={door.id} />
          </Col>
          <Col xs={12} md={4}>
            <DisplayField label="Name" value={door.name || '-'} />
          </Col>
          <Col xs={12} md={4}>
            <DisplayField label="Room ID" value={door.roomId} />
          </Col>

          <Col xs={12} md={4}>
            <DisplayField label="Floor ID" value={door.floorId} />
          </Col>
          <Col xs={12} md={4}>
            <DisplayField label="Building ID" value={door.buildingId} />
          </Col>
          <Col xs={12} md={4}>
            <DisplayField label="Created By" value={door.createdBy || '-'} />
          </Col>

          <Col xs={12} md={4}>
            <DisplayField label="Created At" value={fmtDate(door.createdAt)} />
          </Col>
          <Col xs={12} md={4}>
            <DisplayField label="Updated By" value={door.updatedBy || '-'} />
          </Col>
          <Col xs={12} md={4}>
            <DisplayField label="Updated At" value={fmtDate(door.updatedAt)} />
          </Col>

          <Col xs={12}>
            <DisplayField label="Description" value={door.description || 'No description available'} />
          </Col>

          {/* If you later add doorType:
          <Col xs={12} md={4}>
            <DisplayField label="Door Type" value={door.doorType ?? '-'} />
          </Col>
          */}
        </Row>

        <div className="d-flex justify-content-end mt-2">
          <Button variant="primary" onClick={onHide}>Close</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewDoorModule;
